import * as React from "react";
import { IsSessionExpiredContext } from "src/modules/Auth/AuthExpiration/AuthExpirationContext";

export const useIsSessionExpired = (): boolean => {
  const [isExpired] = React.useContext(IsSessionExpiredContext)
  return isExpired;
}


// WEBPACK FOOTER //
// ./src/modules/Auth/AuthExpiration/useIsSessionExpired.tsx